import React, { useEffect, useState } from "react";
import FailedModal from "../../../../CustomModal/Failed";
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import Header from "../../../../layout/header";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import { toast } from "react-toastify";

const UCDActivitySave = ({
  history,
  match,
  NewActivityDetails = [],
  saveActivity
}) => {
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const islatlng = useLatLng();
  const [isLoading, setIsLoading] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [inputList, setInputList] = useState([
    {
      meta_data: {},
      lat: "",
      long: "",
      next_activity_type_id: "",
      next_activity_date: "",
      module_type: ""
    },
  ]);
    const [currentDate, setCurrentDate] = useState(
      now.toISOString().slice(0, 16)
    )

      const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList];
        inputList[0][key] = val;
        setInputList(list);
      };
    
      useEffect(() => {
        setIsFailedModalOpen(false);
        if (NewActivityDetails?.status === 200) {
          toast.success(NewActivityDetails?.message);
          window.location.href = `ucd-activity-list/${match?.params?.id}`;
        } else if (
          NewActivityDetails?.status !== undefined &&
          NewActivityDetails?.status !== 200
        ) {
          setCountToOpenModal(countToOpenModal + 1);
          setIsFailedModalOpen(true);
        }
      }, [NewActivityDetails]);
    
        const handleSubmit = async (e) => {
            e.preventDefault()
            let list = inputList[0]
            console.log(list)
            list['next_activity_type_id'] = 49;
            list['account_id'] = match?.params?.id;
        
        

        list['module_type'] = 'UCD';
        list['module_name'] = 'is_ucd';
        list['check_pending_meeting_globally'] = 0;
        
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
    
        // list["attendance_id"] = checkInId;
        if (list["long"] == null || list["lat"] == null) {
          toast.error("Please enable your location");
          return false;
        }
        // console.log("listlistlist "+JSON.stringify(list))
        // return false
        setIsLoading(true);
        await saveActivity(list);
        setIsLoading(false);
      };
    
      
  return (
    <>
      <FailedModal
        isOpen={isFailedModalOpen}
        msg={NewActivityDetails?.message}
        countToOpenModal={countToOpenModal}
      />
      <Loader isLoading={isLoading} />

      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Activity"} history={history} />
            {/*BODY*/}

            <div className="container-fluid common-bg">
            <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                          <h1 className="h3 mb-0 text-black-100">
                            {/* <span style={{ color: "green" }}>{distance}</span> */}
                          </h1>
                        </div>
                        <div className="card-body bg-white">
                          <div className="user">
                            <div className="form-group row">
                            <div className="col-sm-6 mt-1 float-field"
                                style={{ marginTop: "16px !important" }}
                                >
                                <select
                                    className="form-control form-control-user"
                                >
                                    <option value="UCD" disabled selected>
                                    UCD
                                    </option>
                                </select>
                                <label className="large-label float-lb">Schedule Activity</label>
                                </div>
                              <div className="col-sm-6 mtk-075 float-field">
                                <input
                                  type="datetime-local"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(
                                      "next_activity_date",
                                      e.target.value,
                                      e
                                    );
                                    setCurrentDate(e.target.value);
                                  }}
                                  my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                                  id="validationCustom01"
                                  min={
                                    new Date().toISOString().split("T")[0] +
                                    "T00:00"
                                  }
                                  value={currentDate}
                                />
                                <label className="large-label float-lb">
                                  Activity Date
                                </label>
                              </div>

                              
                              <div className="col-sm-6 mtk-075 float-field mb-4">
                                <textarea
                                  className="form-control form-control-user"
                                  placeholder=" Description"
                                  onChange={(e) => {
                                    handleInput(
                                      "description",
                                      e.target.value,
                                      "",
                                      e
                                    );
                                  }}
                                  id="validationCustom01"
                                  rows="4"
                                  cols="50"
                                  required={true}
                                />
                                <label className="large-label float-lb">
                                  {/*Description*/}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*</div>*/}
                        <div className="col-md-12 mt-4 d-flex">
                          <button className="btn btn-primary btn-user btn-block submit-btn">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default UCDActivitySave;
